import React from "react"
import { graphql } from "gatsby"

import * as S from "../components/Post/styled"

import Layout from "../components/Layout"
import SEO from "../components/Seo"
import Comments from "../components/Comments"

const BlogPost = ({ data }) => {
  const post = data.markdownRemark
  const image = post.frontmatter.image
    ? post.frontmatter.image.childImageSharp.resize.src
    : ""

  return (
    <Layout>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description}
        image={image}
      />
      <S.BlogPostContainer>
        <S.BlogPostInfo>
          <S.BlogPostTitle> {post.frontmatter.title} </S.BlogPostTitle>
          <S.BlogPostDate> {post.frontmatter.date} </S.BlogPostDate>
          <S.BlogPostLengthTime>
            {" "}
            | {post.timeToRead} min de leitura{" "}
          </S.BlogPostLengthTime>
          <S.BlogPostCategory>
            {" "}
            Categoria: {post.frontmatter.category}{" "}
          </S.BlogPostCategory>
        </S.BlogPostInfo>

        <S.BlogPostContent
          dangerouslySetInnerHTML={{ __html: post.html }}
        ></S.BlogPostContent>
      </S.BlogPostContainer>
      <Comments url={post.fields.slug} title={post.frontmatter.title} />
    </Layout>
  )
}

export const query = graphql`
  query Post($slug: String) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      fields {
        slug
      }
      frontmatter {
        title
        background
        category
        description
        date(locale: "pt-br", formatString: "DD [de] MMMM [de] YYYY")
        image {
          childImageSharp {
            fluid(maxWidth: 900, quality: 90) {
              ...GatsbyImageSharpFluid
            }
            resize(width: 600, quality: 50) {
              src
            }
          }
        }
      }
      html
      timeToRead
    }
  }
`

export default BlogPost
